import { CompactMeta_User } from '__generated__/CompactMeta_User';
import classNames from 'classnames';
import Responsive from 'common/components/Responsive';
import Avatar from 'projects/components/Avatar';
import DesignerMetaContext from 'projects/components/DesignerMetaContext';
import LocalTime from 'projects/components/LocalTime';
import OnlineStatus from 'projects/components/OnlineStatus';
import StatsTable from 'projects/components/StatsTable';
import { isDesignerOnline } from 'projects/util/designer';
import * as React from 'react';

export interface Props {
    designer: CompactMeta_User;
    onRemove?: (userId: number) => void;
    hasFullStats?: boolean;
}

const CompactMeta = ({ designer, hasFullStats = true, onRemove }: Props) => {
    const isOnlineNow = isDesignerOnline(designer);

    return (
        <DesignerMetaContext.Consumer>
            {({ hasResponsiveness }) => (
                <div
                    className={classNames({
                        'designer-meta': true,
                        'designer-meta--minimal': !hasFullStats,
                        'designer-meta-compact': true,
                    })}
                >
                    <div className="designer-meta__avatar">
                        <Responsive max="small">
                            <Avatar
                                userId={designer.id}
                                variations={['small']}
                                isOnline={isOnlineNow}
                                onRemove={onRemove}
                            />
                        </Responsive>
                        <Responsive min="medium">
                            <Avatar
                                userId={designer.id}
                                variations={['medium']}
                                isOnline={isOnlineNow}
                                onRemove={onRemove}
                            />
                        </Responsive>
                    </div>
                    <div className="designer-meta__name">
                        <div className="paragraph paragraph--text paragraph--regular paragraph--no-margin">
                            {designer.displayName}
                        </div>
                    </div>
                    {hasFullStats && (
                        <div>
                            {hasResponsiveness && (
                                <div className="designer-meta__responsiveness">
                                    <StatsTable.Stat
                                        horizontal
                                        amount={`${designer.profile.responsivenessScore}%`}
                                        label={__('Responds within 24 hours')}
                                    />
                                </div>
                            )}
                            <div className="designer-meta__online-status">
                                <OnlineStatus
                                    isOnline={isOnlineNow}
                                    lastSeenAt={designer.profile.lastSeenAt}
                                />
                            </div>
                            <LocalTime utcOffset={designer.profile.utcOffset} />
                        </div>
                    )}
                </div>
            )}
        </DesignerMetaContext.Consumer>
    );
};
export default CompactMeta;
